'use client';

import { ThemeColor, themeColors } from '@/lib/config/colors';
import { useTheme } from '@/lib/utils/themeContext';
import classNames from 'classnames';
import { HeadlinePosition } from './Headline';

type SubheaderProps = {
  as?: string;
  position?: HeadlinePosition;
  color?: ThemeColor;
  children: React.ReactNode;
};

const Subheader = ({ as = 'p', position = 'left', color, children }: SubheaderProps) => {
  const theme = useTheme();
  const Component = as as keyof JSX.IntrinsicElements;

  return (
    <Component
      className={classNames(
        'text-3xl font-semibold leading-normal',
        '[h1_+_&]:text-xl [h1_+_&]:mb-4 [h1_+_&]:-mt-4 md:[h1_+_&]:text-3xl md:[h1_+_&]:mb-8 md:[h1_+_&]:-mt-6',
        '[h2_+_&]:text-xl [h2_+_&]:mb-4 [h2_+_&]:-mt-3 md:[h2_+_&]:text-3xl md:[h2_+_&]:mb-8',
        '[h3_+_&]:text-lg [h3_+_&]:mb-3 [h3_+_&]:-mt-2 md:[h3_+_&]:text-2xl md:[h3_+_&]:mb-4 md:[h3_+_&]:-mt-2',
        '[h4_+_&]:text-lg [h4_+_&]:mb-3',
        '[h5_+_&]:text-lg [h5_+_&]:mb-3',
        '[h6_+_&]:text-lg [h6_+_&]:mb-3',
        themeColors[color || theme.color][600].color,
        {
          'text-center': position === 'center',
          'text-right': position === 'right',
        }
      )}
    >
      {children}
    </Component>
  );
};

export default Subheader;
